import { useNavigate } from 'react-router-dom';
import { FlaskConicalIcon } from 'lucide-react';
import { Button } from '@bcecloud/portal-ui';
import { toast } from 'sonner';
import { leaveSandbox, resetSandbox } from '@/sandbox/mode';

/**
 * The band across the top while the sandbox is on: a reminder that nothing
 * here is saved, a Reset back to the seed, and the way out.
 */
export function SandboxBanner(): React.ReactElement {
  const navigate = useNavigate();
  return (
    <div data-guide="sandbox-banner" className="flex flex-wrap items-center justify-between gap-3 border-b border-amber-300 bg-amber-100 px-4 py-2 text-portal-small text-portal-ink min-[720px]:px-[34px]">
      <span className="flex items-center gap-2">
        <FlaskConicalIcon aria-hidden className="size-4 text-amber-700" />
        <strong className="font-bold">Sandbox.</strong> Try anything here, nothing is saved.
      </span>
      <span className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="compact"
          onClick={() => {
            resetSandbox();
            toast.success('Sandbox reset');
          }}
        >
          Reset
        </Button>
        <Button
          size="compact"
          onClick={() => {
            const returnTo = leaveSandbox();
            navigate(returnTo);
          }}
        >
          Leave sandbox
        </Button>
      </span>
    </div>
  );
}
